<div class="border p-3 rounded shadow-sm">
  <div class="row g-2 align-items-center">
    <div class="col-lg-5">
      <div class="row">
        <div class="col-6">
          <p class="mb-1"><strong>{{ 'Vendor ID' | wordReplace }}</strong> : {{vendorMarketID}}</p>
          <p class="mb-1"><strong>Name</strong> : {{vendorName}}</p>
        </div>
        <div class="col-6">
          <p class="mb-1"><strong>Telephone</strong> : {{telephone | phoneFormat}}</p>
          <p class="mb-1"><strong>Email</strong> : {{Email}}</p>
        </div>
      </div>
    </div>
    <div class="col-lg-7 text-lg-end align-items-center gap-2">
      <button class="btn btnAS" (click)="addAttachment()">Add Attachments</button>
    </div>
  </div>
</div>
<div class="row mt-2">
  <div class="col-12 text-start">
    <ejs-grid [dataSource]="attachments" [allowPaging]="false" [allowSorting]="false" height="200">
      <e-columns>
        <e-column field="Attachments" headerText="Attachments" width="100"></e-column>
        <e-column field="AddedOn" headerText="Added On" width="200" format="MM/dd/yyyy"></e-column>
        <e-column field="AddedBy" headerText="Added By" width="120"></e-column>
        <e-column field="view" headerText="View" textAlign="Center" width="100">
          <ng-template #template let-data>
            <a (click)="openPreview(data); $event.stopPropagation()"><img src="./assets/images/view.svg"
                class="img-fluid" /></a>
          </ng-template>
        </e-column>
        <e-column field="Remove" headerText="Remove" width="100" textAlign="Center">
          <ng-template #template let-data>
            <a (click)="deleteAttachment(data); $event.stopPropagation()">
              <img src="./assets/images/delete.svg" class="img-fluid" /></a>
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
<!--Attachment Modal -->
<div class="modal fade" id="attachmentModal" tabindex="-1" aria-labelledby="attachmentModal" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="attachmentModal">Add Attachment</h1>
        <button type="button" class="btn-close" (click)="closeModalById('attachmentModal')"></button>
      </div>
      <form [formGroup]="attachmentForm">
        <div class="modal-body">
          <div class="form-layout">
            <!-- Left column (fields) -->
            <div class="form-fields">
              <!-- Name -->
              <div class="form-row mb-3">
                <label for="name" class="form-label">Name<span class="text-danger">*</span></label>
                <input type="text" id="name" maxlength="100" class="form-control" formControlName="AttachmentName">
              </div>
              <!-- File Path -->
              <div class="form-row mb-3">
                <label for="filePath" class="form-label">File Path<span class="text-danger">*</span></label>
                <input type="file" id="filePath" class="form-control" (change)="onFileSelected($event)"
                  accept=".png,.jpg,.jpeg,.pdf">
              </div>
              <!-- Notes -->
              <div class="form-row mb-3">
                <label for="notes" class="form-label">Notes<span class="text-danger">*</span></label>
                <input type="text" id="notes" maxlength="150" class="form-control" formControlName="Notes">
              </div>
            </div>
            <!-- Right column (preview) -->
            <div class="preview-col">
              <div class="preview-box">
                <!-- Image Preview -->
                <img *ngIf="isImageFile && previewUrl" [src]="previewUrl"
                  class="img-fluid h-100 w-100 object-fit-contain" alt="Preview">
                <!-- PDF Preview -->
                <iframe *ngIf="isPdfFile && previewUrl" [src]="previewUrl" class="w-100 h-100" style="border: none;"
                  title="PDF Preview"></iframe>
                <!-- Empty -->
                <span *ngIf="!previewUrl" class="text-muted">No Preview</span>
              </div>
              <label class="mt-2">Preview</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btnAS me-1" (click)="saveAttachment()">Save</button>
          <button type="button" class="btn btn-orange" (click)="closeModalById('attachmentModal')">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Preview Modal -->
<div class="modal fade" id="previewAttachmentModal" tabindex="-1" role="dialog"
  aria-labelledby="previewAttachmentLabel">
  <div class="modal-dialog modal-dialog-centered modal-fullSize modal-lg ">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Preview</h5>
        <button type="button" class="btn-close" (click)="closeModalById('previewAttachmentModal')">
        </button>
      </div>
      <div class="modal-body previewModal text-center">
        <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="height:300px;">
          <div class="spinner-border text-primary" role="status"></div>
        </div>
        <!-- Image Preview -->
        <div *ngIf="isImageFile">
          <img [src]="previewFileUrl" id="attachmentImageIframe" width="500px" height="500px" class="img-fluid"
            alt="Preview" />
        </div>
        <!-- PDF Preview -->
        <div *ngIf="isPdfFile">
          <iframe id="previewprintf" #previewIframe width="100%" height="500px" frameborder="0"></iframe>
        </div>
        <!-- Other file types -->
        <div *ngIf="!loading && !isImageFile && !isPdfFile">
          <p>Unsupported file format.</p>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-orange" (click)="closeModalById('previewAttachmentModal')">Close</button>
      </div>
    </div>
  </div>
</div>